import ErrorCmpxsLack from "./error-cmpxs-lack";
export default ErrorCmpxsLack;
